"use client";
import ReactPaginate from "react-paginate";
import { useRouter } from "next/navigation";

const BlogPagination = ({ lastPage, currentPage, perPage, total }) => {
  const router = useRouter();

  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(currentPage * perPage, total);

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    const url = new URL(window.location.href);
    url.searchParams.set("page", selectedPage);
    router.push(url.pathname + url.search);
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="text-[14px] font-semibold text-user-paragraph">
        {total > 0 ? `Showing ${start} to ${end} of ${total}` : "No results"}
      </p>
      <div className="main-pagination">
        <ReactPaginate
          forcePage={currentPage - 1}
          breakLabel="..."
          nextLabel="Next"
          previousLabel="Previous"
          onPageChange={handlePageClick}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          pageCount={lastPage || 0}
          breakClassName="cursor-pointer"
          breakLinkClassName="w-full h-full flex items-center justify-center font-bold text-[rgba(45,45,45,0.60)]"
          containerClassName="flex items-center space-x-2"
          pageClassName="h-[30px] w-[30px] flex items-center justify-center font-bold hover:text-user-primary text-[rgba(45,45,45,0.60)] cursor-pointer"
          pageLinkClassName="w-full h-full flex items-center justify-center"
          activeClassName="text-user-primary"
          previousClassName="flex items-center justify-center text-[14px] text-user-text font-bold cursor-pointer hover:text-user-text"
          previousLinkClassName="w-full h-full flex items-center justify-center"
          nextClassName="flex items-center justify-center text-[14px] text-user-text font-bold cursor-pointer hover:text-user-text"
          nextLinkClassName="w-full h-full flex items-center justify-center"
          disabledClassName="opacity-50 cursor-not-allowed"
        />
      </div>
    </div>
  );
};

export default BlogPagination;
